export enum Roles {
    ADMIN = 'administrador',
    MANAGERS = 'gerentes',
    RUNNER = 'runner',
    OPERATIONS_MANAGER = 'jefe_operaciones'
}

export enum Items {
    PRODUCT = 'PRODUCT',
    SERVICE = 'SERVICE'
}

export enum TransportationOrderStatuses {
    ACTIVO = 'ACTIVO',
    FINALIZADO = 'FINALIZADO',
    ANULADO = 'ANULADO'
}

export enum TransportationOrderItemStatuses {
    PREPARACION = 'PREPARACION',
    DESPACHO = 'DESPACHO',
    FINALIZADO = 'FINALIZADO',
    ANULADO = 'ANULADO'
}


export enum ServiceManifestStatuses {
    DRAFT = 'DRAFT',
    CONFIRMED = 'CONFIRMED',
    ANNULLED = 'ANNULLED'
}

export enum PurchaseOrderStatuses {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    CONFIRMED = 'CONFIRMED',
    ANNULLED = 'ANNULLED'
}

export enum AccountingStatuses {
    ACCOUNTED = 'ACCOUNTED',
    IN_PROGRESS = 'IN_PROGRESS'
}

export enum ServiceType {
    TRANSPORT = 'TRANSPORT',
    STORAGE = 'STORAGE'
}

export enum BusinessEntities {
    SOCIETY = 'SOCIETY',
    PROVIDER = 'PROVIDER',
    CLIENT = "CLIENT"
}

export enum TransferTypes {
    PROVIDER_PAY = 'PROVIDER_PAY',
    CLIENT_PAY = 'CLIENT_PAY',
}

export enum PaymentStatusEnum {
    BORRADOR = 'BORRADOR',
    REVISION = 'REVISION',
    APROBADO = 'APROBADO',
    ANULADO = 'ANULADO'
}

export enum DispatchProgramStatusEnum{
    DESPACHO = "DESPACHO", 
    FINALIZADO = "FINALIZADO", 
    ANULAR = "ANULAR", 
}

export enum DispatchProgramItemStatusEnum{
    PREPARACION = "PREPARACION",
    PLANIFICACION = "PLANIFICACION",
    DESPACHO = "DESPACHO", 
    FINALIZADO = "FINALIZADO", 
    ANULAR = "ANULAR", 
}

export enum SalesInvoiceStatusEnum {
    BORRADOR = 'BORRADOR',
    CONTABILIZADA = 'CONTABILIZADA',
    ANULADA = 'ANULADA',
}

export enum TaxDocumentStatusEnum {
    BORRADOR = 'BORRADOR',
    CONTABILIZADA = 'CONTABILIZADA',
    ANULADA = 'ANULADA'
}

export enum PurchaseDocumentStatusEnum {
    BORRADOR = 'BORRADOR',
    CONTABILIZADA = 'CONTABILIZADA',
    ANULADA = 'ANULADA'
}


export enum ExchangeRateDateEnum {
    FECHA_FACTURA = 'FECHA_FACTURA',
    FECHA_FIJA = 'FECHA_FIJA',
    ULTIMO_DIA_MES_ENTREGA = 'ULTIMO_DIA_MES_ENTREGA',
    FECHA_ENTREGA = 'FECHA_ENTREGA',
    PRIMER_DIA_MES_ENTREGA = 'PRIMER_DIA_MES_ENTREGA',
    VALOR_MIN_MES_ENTREGA = 'VALOR_MIN_MES_ENTREGA',
    VALOR_MAX_MES_ENTREGA = 'VALOR_MAX_MES_ENTREGA'
}

export enum SectorBusinessRulesEnum {
    STC_Transporte_de_Carga = "[STC] Transporte de Carga",
    WHS_Almacenamiento = "[WHS] Almacenamiento",
    DEFECTO = "DEFECTO",
    NO_ALICA = "NO_APLICA"
}

export enum QuoteDetailFormTypeEnum {
    DEFAULT = "DEFAULT",
    TRANSPORT = "TRANSPORT",
    WAREHOUSE = "WAREHOUSE"
}

export enum RatePeriodEnum {
    DIA = "DIA",
    SEMANA = "SEMANA",
    MES = "MES",
    AÑO = "AÑO"
}

export enum ExchangeRateDateSourceEnum {
    BANCO_CENTRAL_CHILE = 'BANCO_CENTRAL_CHILE',
}

export enum QuoteMaxPaymentsEnum {
    UN_PAGO = '1',
    HASTA_DOS_PAGOS = '2'
}


export enum WarehouseOrderStatuses {
    BORRADOR = 'BORRADOR',
    CONFIRMADO = 'CONFIRMADO',
    CERRADO = 'CERRADO',
    ANULADO = 'ANULADO'

}

export enum WarehouseOrderItemStatuses {
    PREPARACION = 'PREPARACION',
    DESPACHO = 'DESPACHO',
    FINALIZADO = 'FINALIZADO',
    ANULADO = 'ANULADO'
}


